import { IThemes } from "../ts/themes/themes.types";
const themes: IThemes = {
  kabutar: {
    name: "kabutar",
    primary: {
      text: "white",
      main: "#0b525b",
    },
    secondary: {
      text: "black",
      main: "#cddafd",
    },
  },
  jhirki: {
    name: "jhirki",
    primary: {
      text: "white",
      main: "#390099",
    },
    secondary: {
      text: "black",
      main: "#faf0ca",
    },
  },
  thesi: {
    name: "thesi",
    primary: {
      text: "white",
      main: "#001233",
    },
    secondary: {
      text: "black",
      main: "#ccc",
    },
  },
  nehtad: {
    name: "nehtad",
    primary: {
      text: "black",
      main: "#7ae582",
    },
    secondary: {
      text: "black",
      main: "#f5cb5c",
    },
  },
};
export default themes;
